import { useEffect } from 'react'

export const useThemeColor = (color: string, preventScroll: boolean = false) => {
	useEffect(() => {
		// Set theme-color meta tag
		let metaThemeColor = document.querySelector(
			'meta[name=theme-color]'
		) as HTMLMetaElement | null

		if (!metaThemeColor) {
			metaThemeColor = document.createElement('meta')
			metaThemeColor.setAttribute('name', 'theme-color')
			document.head.appendChild(metaThemeColor)
		}

		metaThemeColor.setAttribute('content', color)
	}, [color])

	useEffect(() => {
		// Prevent page scroll when menu is open
		if (preventScroll) {
			// Capture scroll position RIGHT NOW
			const scrollY = window.scrollY || window.pageYOffset
			const backgroundColor = document.body.style.backgroundColor

			// Lock body scroll with fixed position
			document.body.style.position = 'fixed'
			document.body.style.top = `-${scrollY}px`
			document.body.style.left = '0'
			document.body.style.right = '0'
			document.body.style.width = '100%'

			if (window.innerWidth < 1100) {
				document.body.style.backgroundColor = '#4A337A'
			}

			// Store for cleanup
			document.body.dataset.scrollY = scrollY.toString()

			return () => {
				// Restore on cleanup
				const savedScrollY = document.body.dataset.scrollY
				document.body.style.position = ''
				document.body.style.top = ''
				document.body.style.left = ''
				document.body.style.right = ''
				document.body.style.width = ''
				document.body.style.backgroundColor = backgroundColor

				// Temporarily disable smooth scroll
				const htmlElement = document.documentElement
				const originalScrollBehavior = htmlElement.style.scrollBehavior
				htmlElement.style.scrollBehavior = 'auto'

				// Restore scroll instantly
				if (savedScrollY) {
					window.scrollTo(0, parseInt(savedScrollY))
				}

				// Restore smooth scroll after a frame
				requestAnimationFrame(() => {
					htmlElement.style.scrollBehavior = originalScrollBehavior
				})
			}
		}
	}, [preventScroll])
}
